export default __webpack_public_path__ + "static/media/wallpaper_01.95c7c6b1.jpg";